import { render, staticRenderFns } from "./convertidos.vue?vue&type=template&id=f122288a"
import script from "./convertidos.vue?vue&type=script&lang=js"
export * from "./convertidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports